export default {
  setSearchText (state: {[key:string]: string}, payload: string) {
    state.searchText = payload
  },
  setOrderName (state: {[key:string]: string}, name: string) {
    state.orderName = name
  },
  setSortAsc (state: {[key:string]: boolean}, sort: boolean) {
    state.sortAsc = sort
  },
  setStep (state: {[key:string]: number}, step: number) {
    state.step = step
  },
  setRentStatus (state: {[key:string]: number}, rentStatus: number) {
    state.rentStatus = rentStatus
  },
  setGroupId (state: {[key:string]: number}, groupId: number) {
    state.groupId = groupId
  },
  setMachineId (state: {[key:string]: number}, machineId: number) {
    state.machineId = machineId
  },
  setMachineType (state: {[key:string]: number}, machineType: number) {
    state.machineType = machineType
  },
  setCreatedAt (state: {[key:string]: number}, createdAt: number) {
    state.createdAt = createdAt
  },
  setCreatedBy (state: {[key:string]: number}, createdBy: number) {
    state.createdBy = createdBy
  },
  setCreatedType (state: {[key:string]: number}, createdType: number) {
    state.createdType = createdType
  },
  setRentStartDate (state: {[key:string]: number}, rentStartDate: number) {
    state.rentStartDate = rentStartDate
  },
  setRentEndDate (state: {[key:string]: number}, rentEndDate: number) {
    state.rentEndDate = rentEndDate
  },
  setUseStartDate (state: {[key:string]: number}, useStartDate: number) {
    state.useStartDate = useStartDate
  },
  setUseEndDate (state: {[key:string]: number}, useEndDate: number) {
    state.useEndDate = useEndDate
  },
  setLimit (state: {[key:string]: number}, limit: number) {
    state.limit = limit
  },
  setCurrentPage (state: {[key:string]: number}, page: number) {
    state.page = page
  },
  // 圃場選択モーダル用
  setFieldSearchText (state: {[key:string]: string}, payload: string) {
    state.fieldSearchText = payload
  },
  setFieldCurrentPage (state: {[key:string]: number}, page: number) {
    state.fieldCurrentPage = page
  },
  setFieldOrderName (state: {[key:string]: string}, name: string) {
    state.fieldOrderName = name
  },
  setFieldSortAsc (state: {[key:string]: boolean}, sort: boolean) {
    state.fieldSortAsc = sort
  },
  // 除草警報から貸出追加に遷移した際の初期値用
  setInitialFieldId (state: {[key:string]: number}, initialFieldId: number) {
    state.initialFieldId = initialFieldId
  },
  setAccountId (state: {[key:string]: number}, name: number) {
    state.accountId = name
  }
}
